/**
 * Import Dependency
 */
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import * as userAction from 'actions/components/user'
import * as switchLocaleActions from 'actions/components/intl'
import * as merchantActions from 'actions/components/merchant'
import * as categoryActions from 'actions/components/category'
import * as orderActions from 'actions/components/basket'
import * as stepperActions from 'actions/components/stepper'
import * as queryActions from 'actions/components/query'
import * as packagesActions from 'actions/components/packages'
import * as promocodesActions from 'actions/components/promocodes'
import * as historyActions from 'actions/components/history'
import * as formActions from 'actions/components/form'
import * as tableActions from 'actions/components/table'
import * as menuActions from 'actions/components/menu'
import * as waiterActions from 'actions/components/waiter'

/**
 * Import Component
 */
import Wrap from 'components/scenes/Wrap'

/**
 * Declare Variable
 */
const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
    categories: state.categories,
    user: state.user,
    basket: state.basket,
    isStickyNavbarSwiper: state.isStickyNavbarSwiper,
    orders: state.orders,
    isTakeaway: state.basket.isTakeaway,
    isTakeawayAvailable: state.basket.isTakeawayAvailable,
    isNavBarSwiperExpanded: state.isNavBarSwiperExpanded,
    locale: state.locale,
    query: state.query,
    packages: state.packages,
    form: state.form,
    waiter: state.waiter,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators(switchLocaleActions, dispatch),
    ...bindActionCreators(merchantActions, dispatch),
    ...bindActionCreators(categoryActions, dispatch),
    ...bindActionCreators(stepperActions, dispatch),
    ...bindActionCreators(queryActions, dispatch),
    ...bindActionCreators(historyActions, dispatch),
    ...bindActionCreators(tableActions, dispatch),
    ...bindActionCreators(promocodesActions, dispatch),
    ...bindActionCreators(packagesActions, dispatch),
    ...bindActionCreators(orderActions, dispatch),
    ...bindActionCreators(formActions, dispatch),
    ...bindActionCreators(userAction, dispatch),
    ...bindActionCreators(menuActions, dispatch),
    ...bindActionCreators(waiterActions, dispatch),
  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(Wrap)))



// WEBPACK FOOTER //
// ./src/containers/scenes/Wrap.js